export const fileValidation = async (files,
    setTextFiles,
    setGenerationStatus,
    generatedZips,
    setValidationErrors,
    setIsErrorModalOpen) => {
    const txtFiles = files.filter(file => file.name.endsWith('.txt'));

    setTextFiles(txtFiles);
    setGenerationStatus(
        <p className="text-green-500 font-semibold">
            ✅ Selected {txtFiles.length} file(s). Ready to process.
        </p>
    );
    generatedZips.current = [];
    let hasEditPattern = false;
    let hasSpeakerPattern = false;
    let hasTimecodePattern = false;
    let hasPattern1 = false;
    let hasPattern2 = false;
    let hasPattern3 = false;
    let hasInc = false;
    let hasCopyright = false;
    let hasLtd = false;
    let hasEducation = false;
    let editPatternFiles = [];
    let speakerPatternFiles = [];
    let timecodePatternFiles = [];
    let pattern1Files = [];
    let pattern2Files = [];
    let pattern3Files = [];
    let incFiles = [];
    let copyrightFiles = [];
    let ltdFiles = [];
    let educationFiles = [];

    for (const file of txtFiles) {
        let fileHasEditPattern = false;
        let fileHasSpeakerPattern = false;
        let fileHasTimecodePattern = false;
        let fileHasPattern1 = false;
        let fileHasPattern2 = false;
        let fileHasPattern3 = false;
        let fileHasInc = false;
        let fileHasCopyright = false;
        let fileHasLtd = false;
        let fileHasEducation = false;

        try {
            const text = await file.text();
            const lines = text.split('\n');
            for (const line of lines) {
                const trimmedLine = line.trim();
                if (/^Edit\d{2}$/.test(trimmedLine)) {
                    fileHasEditPattern = true;
                    hasEditPattern = true;
                }
                if (/^Speaker\d+$/.test(trimmedLine)) {
                    fileHasSpeakerPattern = true;
                    hasSpeakerPattern = true;
                }
                // Checking for the timecode pattern "00:00:08.300" or "00:00:08:30"
                if (/\d{2}:\d{2}:\d{2}:\d{3}/.test(trimmedLine) || /\d{2}:\d{2}:\d{2}:\d{2}/.test(trimmedLine) || /\d{2}:\d{2}:\d{2}.\d{2}/.test(trimmedLine) || /\d{2}:\d{2}:\d{2}.\d{3}/.test(trimmedLine)) {
                    fileHasTimecodePattern = true;
                    hasTimecodePattern = true;
                }
                if (/\d{2}:\d{2}\s?-\s?\d{2}-\d{2}/.test(trimmedLine)) {
                    fileHasPattern1 = true;
                    hasPattern1 = true;
                }
                if (/\d{2}-\d{2}\s?-\s?\d{2}:\d{2}/.test(trimmedLine)) {
                    fileHasPattern2 = true;
                    hasPattern2 = true;
                }
                if (/\d{2}-\d{2}\s?-\s?\d{2}-\d{2}/.test(trimmedLine)) {
                    fileHasPattern3 = true;
                    hasPattern3 = true;
                }
                if (trimmedLine.toLowerCase().includes('inc.')) {
                    fileHasInc = true;
                    hasInc = true;
                }
                if (trimmedLine.includes('©')) {
                    fileHasCopyright = true;
                    hasCopyright = true;
                }
                if (trimmedLine.toLowerCase().includes('ltd.')) {
                    fileHasLtd = true;
                    hasLtd = true;
                }
                if (trimmedLine.toLowerCase().includes('eduaction')) {
                    fileHasEducation = true;
                    hasEducation = true;
                }
            }
        } catch (error) {
            console.error(`Error reading file ${file.name}:`, error);
            setGenerationStatus(
                <p className="text-red-500 font-semibold">
                    ❌ Error reading file(s). Please check the console.
                </p>
            );
            return; // Exit if there's an error reading a file
        }

        if (fileHasEditPattern) editPatternFiles.push(file.name);
        if (fileHasSpeakerPattern) speakerPatternFiles.push(file.name);
        if (fileHasTimecodePattern) timecodePatternFiles.push(file.name);
        if (fileHasPattern1) pattern1Files.push(file.name);
        if (fileHasPattern2) pattern2Files.push(file.name);
        if (fileHasPattern3) pattern3Files.push(file.name);
        if (fileHasInc) incFiles.push(file.name);
        if (fileHasCopyright) copyrightFiles.push(file.name);
        if (fileHasLtd) ltdFiles.push(file.name);
        if (fileHasEducation) educationFiles.push(file.name);
    }

    const errorMessages = [];

    if (hasEditPattern) {
        errorMessages.push(`❌ Error: The following file(s) contain lines matching the pattern 'Edit[two digit]': ${editPatternFiles.join('\n')}`);
    }
    if (hasSpeakerPattern) {
        errorMessages.push('\n');
        errorMessages.push(`❌ Error: The following file(s) contain lines matching the pattern 'Speaker10': ${speakerPatternFiles.join('\n')}`);
    }
    if (hasTimecodePattern) {
        errorMessages.push('\n');
        errorMessages.push(`❌ Error: The following file(s) contain lines matching the pattern '00:00:01:000': ${timecodePatternFiles.join('\n')}`);
    }
    if (hasPattern1) {
        errorMessages.push('\n');
        errorMessages.push(`❌ Error: The following file(s) contain lines matching the pattern '01:08-02-07': ${pattern1Files.join('\n')}`);
    }
    if (hasPattern2) {
        errorMessages.push('\n');
        errorMessages.push(`❌ Error: The following file(s) contain lines matching the pattern '01-08-02:07': ${pattern2Files.join('\n')}`);
    }
    if (hasPattern3) {
        errorMessages.push('\n');
        errorMessages.push(`❌ Error: The following file(s) contain lines matching the pattern '01-08-02-07': ${pattern3Files.join('\n')}`);

    }
    if (hasInc) {
        errorMessages.push('\n');
        errorMessages.push(`❌ Error: The following file(s) contain the word 'inc.': ${incFiles.join('\n')}`);
    }
    if (hasCopyright) {
        errorMessages.push('\n');
        errorMessages.push(`❌ Error: The following file(s) contain the copyright symbol '©': ${copyrightFiles.join('\n')}`);
    }
    if (hasLtd) {
        errorMessages.push('\n');
        errorMessages.push(`❌ Error: The following file(s) contain the word 'ltd.': ${ltdFiles.join('\n')}`);


    }
    if (hasEducation) {
        errorMessages.push('\n');
        errorMessages.push(`❌ Error: The following file(s) contain the word 'education': ${educationFiles.join('\n')}`);

    }

    if (errorMessages.length > 0) {
        const combinedErrorMessage = errorMessages.join('\n');
        setValidationErrors(combinedErrorMessage);
        setIsErrorModalOpen(true);
        setTextFiles([]);
        return;
    }
};